import React from "react";
import withIntl from "../../../../utils/withIntl";
import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import PrintArticleLine from "../../PrintArticleLine";
import PrintTakeawayOrderView from "./PrintTakeawayOrderView";

function TakeawayOrderLayoutEdit(props) {
  const layoutOptions = props.layoutOptions;
  const setLayoutOptions = props.setLayoutOptions;
  return (
    <>
      <Typography variant={"h6"} style={{ fontWeight: 800 }}>
        Takeaway Kitchen Tickets
      </Typography>
      <Grid container>
        <Grid container spacing={1} item xs={8}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.print_client_details}
                  onChange={(e) => {
                    layoutOptions.ta_order.print_client_details = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print client details"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.print_delivery_costs}
                  onChange={(e) => {
                    layoutOptions.ta_order.print_delivery_costs = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print delivery costs"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.print_payment_costs}
                  onChange={(e) => {
                    layoutOptions.ta_order.print_payment_costs = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print payment costs"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.buzzer ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order.buzzer = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Play buzzer when printing"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.hide_pickup_timestamp ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order.hide_pickup_timestamp = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Hide pickup/delivery timestamp"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.print_total}
                  onChange={(e) => {
                    layoutOptions.ta_order.print_total = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Print subtotal"}
            />
            {layoutOptions.ta_order.print_total && (
              <FormControlLabel
                control={
                  <Checkbox
                    color={"primary"}
                    checked={layoutOptions.ta_order.print_vats ?? true}
                    onChange={(e) => {
                      layoutOptions.ta_order.print_vats = e.target.checked;
                      setLayoutOptions({ ...layoutOptions });
                    }}
                  />
                }
                label={"Print Vats"}
              />
            )}
          </Grid>

          <Grid item xs={12}>
            <Typography style={{ fontWeight: 800 }}>{props.intl.formatMessage({ id: "article_layout" })}</Typography>
            {layoutOptions.ta_order.article &&
              layoutOptions.ta_order.article.lines.map((articleLine, index) => {
                return (
                  <PrintArticleLine
                    articleLine={articleLine}
                    onRemoveLine={() => {
                      layoutOptions.ta_order.article.lines.splice(index, 1);

                      setLayoutOptions({ ...layoutOptions });
                    }}
                    setArticleLine={(newArticleLine) => {
                      articleLine = newArticleLine;
                      let newLayoutOptions = { ...layoutOptions };

                      setLayoutOptions(newLayoutOptions);
                    }}
                  />
                );
              })}
          </Grid>
          <Grid item xs={12}>
            <Button
              variant={"outlined"}
              size={"small"}
              onClick={() => {
                layoutOptions.ta_order.article.lines.push({ elements: [], font_size: "medium" });
                setLayoutOptions({ ...layoutOptions });
              }}
            >
              Add new line
            </Button>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.ta_order.article.newline ?? false}
                  onChange={(e) => {
                    layoutOptions.ta_order.article.newline = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"New line"}
            />
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <PrintTakeawayOrderView layoutOptions={layoutOptions.ta_order} />
        </Grid>
      </Grid>
    </>
  );
}

export default withIntl(TakeawayOrderLayoutEdit);
